import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import FormInput from '../../../commonComponents/forms/FormInput';
import translate from '../../../commonComponents/translate';
import CheckoutTerms from '../../shop/components/CheckoutTerms';
import ConfigsContext from '../../../contextProviders/ConfigsContext';

function AddNoteOrder(props) {
  const { t, isOpportunity, order, onChange, onCheckboxChange, checkedTerms } =
    props;
  const { tenant } = useContext(ConfigsContext);

  const value = isOpportunity ? 'note' : 'adminNotes';
  return (
    <div className="add-note" style={{ paddingTop: 0 }}>
      <h3 className="add-note-title">{t('shop.cart.notes')}</h3>
      <FormInput
        id="notes"
        name="notes"
        value={order?.[value] || ''}
        onChange={onChange(value)}
        placeholder={t('shop.cart.notes.placeholder')}
        type="textarea"
        groupProps={{ className: 'notes' }}
      />
      <CheckoutTerms
        onChange={onCheckboxChange}
        checked={checkedTerms}
        tenant={tenant}
      />
    </div>
  );
}

AddNoteOrder.propTypes = {
  t: PropTypes.func.isRequired,
  isOpportunity: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  order: PropTypes.shape({
    adminNotes: PropTypes.string,
    note: PropTypes.string,
  }),
  checkedTerms: PropTypes.bool,
  onCheckboxChange: PropTypes.func.isRequired,
};

AddNoteOrder.defaultProps = {
  order: {
    adminNotes: '',
    note: '',
  },
  checkedTerms: false,
};

export default translate(AddNoteOrder);
